import React from "react";
import { ReceiptText } from "lucide-react";

/**
 * Full-size Quoting content region. Deliberately minimal and unstructured
 * beyond a single flex container so a future implementation packet can
 * mount an embedded quoting application here without redesigning the Main
 * Card. No iframe, network request, or quote execution exists under IP-008.
 */
export default function QuotingPanel() {
  return (
    <div
      className="flex min-h-[420px] flex-1 flex-col items-center justify-center gap-2 p-5 text-center"
      data-testid="workspace-quoting-panel"
    >
      <ReceiptText className="h-6 w-6 text-slate-600" aria-hidden="true" />
      <p className="text-sm font-medium text-slate-300">Quoting</p>
      <p className="text-xs text-slate-500">Available in a future release.</p>
    </div>
  );
}
